import React, { useState } from 'react';

import IconButton from '@liquidweb-dev/undercurrent/IconButton';
import Menu from '@liquidweb-dev/undercurrent/Menu';

/** Only use this hook if `IconButtonMenu` and `IconButtonMenuItem` is not sufficient */
export const useIconButtonMenu = () => {
	const [menuAnchorEl, setMenuAnchorEl] = useState(null);
	const handleAnchorClick = (event) => {
		setMenuAnchorEl(event.currentTarget);
	};
	const handleCloseMenu = () => {
		setMenuAnchorEl(null);
	};
	const open = Boolean(menuAnchorEl);

	return { handleAnchorClick, handleCloseMenu, menuAnchorEl, open };
};

/**
 * @typedef IconButtonMenuProps
 * @property {React.ReactNode} children
 * @property {React.ReactNode} icon
 * @property {import('@liquidweb-dev/undercurrent/IconButton').IconButtonProps} [IconButtonProps]
 * @property {import('@liquidweb-dev/undercurrent/Menu').MenuProps} [MenuProps]
 */

/**
 * Children should be MUI `MenuItem`s
 * @param {IconButtonMenuProps} props
 */
const IconButtonMenu = ({ children, IconButtonProps, MenuProps, icon }) => {
	return (
		<>
			<IconButton variant="primary" size="medium" {...IconButtonProps}>
				{icon}
			</IconButton>
			<Menu {...MenuProps}>{children}</Menu>
		</>
	);
};

export default IconButtonMenu;
